import {Model} from 'MWC';

const timeUnit = 'time_unit';

export default class extends Model {
    static fields;

    constructor(data) {
        super();
        this.creditSum = data.min;
        this.loanTerm = 0;
        this.requiredPayment = 0;
        this.overpayment = 0;
        this.paymentHistory = [];
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;
        // this.setPaymentHistory([]);
        // this.calculateIndicators();
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    getTerms() {
        return [240];
    }

    getFixAmounts() {
        return this.fields.schemes.sort((a, b) => a.order - b.order).map(item => item.amount);
    }

    getNewRequiredPayment(value) {
        const foundObject = this.fields.schemes.find(item => parseFloat(item.amount) === value);
        return foundObject ? foundObject.monthly : 0;
    }
    getNewOverpayment(value) {
        const foundObject = this.fields.schemes.find(item => parseFloat(item.amount) === value);
        return foundObject ? foundObject.overpayment : 0;
    }

    getNewRealRate(value) {
        const foundObject = this.fields.schemes.find(item => parseFloat(item.amount) === value);
        return foundObject ? foundObject.real_rate : 0;
    }

    getNewCreditCost(value) {
        const foundObject = this.fields.schemes.find(item => parseFloat(item.amount) === value);
        return foundObject ? foundObject.total_cost : 0;
    }

    getMaxTermEdge() {
        return this.fields.terms.length - 1;
    }

    getCurrentTerm() {
        return this.loanTerm;
    }

    getCreditTerm() {
        return +this.getTerms()[this.getCurrentTerm()];
    }

    getCreditRate() {
        return this.fields.rate;
    }

    getMonthCommission() {
        return this.fields['month_commission'];
    }

    getOneTimeCommission() {
        return this.fields['one_time_commission'];
    }

    getRequiredPayment() {
        return this.requiredPayment;
    }

    setRequiredPayment(value) {
        this.requiredPayment = value;
    }

    getOverpayment() {
        return this.overpayment;
    }

    setOverpayment(value) {
        this.overpayment = value;
    }

    getTimeUnit() {
        return this.fields[timeUnit];
    }

    getPaymentHistory() {
        return this.paymentHistory;
    }

    setPaymentHistory(data) {
        this.paymentHistory = data;
    }

    buildPaymentPlan() {
        const creditTerm = this.getCreditTerm(),
            creditSum = this.getCreditSum(),
            paymentHistory = this.getPaymentHistory();

        for (let month = 0; month < creditTerm; month++) {
            paymentHistory[month] = {};

            if (!month) {
                paymentHistory[month].writingOff = 0;
                paymentHistory[month].repayment = this.defineRepayment(paymentHistory, month);
                paymentHistory[month].endBalance = paymentHistory[month].debt =
                    creditSum - paymentHistory[month].repayment;
            } else {
                paymentHistory[month].writingOff = this.defineWritingOff(paymentHistory, month);
                paymentHistory[month].repayment = this.defineRepayment(paymentHistory, month);
                paymentHistory[month].debt = this.calculateMonthBalance(paymentHistory, month);
                paymentHistory[month].endBalance =
                    paymentHistory[month].debt - paymentHistory[month].writingOff;
            }
        }

        this.setPaymentHistory(paymentHistory);
    }

    findAverageRepayment() {
        const paymentHistory = this.getPaymentHistory(),
            creditSum = this.getCreditSum(),
            creditTerm = this.getCreditTerm(),
            monthPayment = Math.round((creditSum / creditTerm) * 100) / 100;
        let sum = 0,
            count = 0;

        for (const item of paymentHistory) {
            if (item.repayment >= monthPayment) {
                sum += item.repayment;
                count++;
            }
        }

        return Math.round((sum / count) * 100) / 100;
    }

    realInterestRate() {
        return (this.getCreditRate() + this.getOneTimeCommission()).toFixed(2);
    }

    findOverpayment() {
        const requiredPayment = this.getRequiredPayment(),
            term = this.getCreditTerm(),
            cerditSum = this.getCreditSum();

        return requiredPayment * term - cerditSum;
    }

    calculateIndicators() {
        this.buildPaymentPlan();

        const averageRepayment = this.findAverageRepayment();
        this.setRequiredPayment(averageRepayment);

        const overpayment = this.findOverpayment();
        this.setOverpayment(overpayment);
    }

    defineRepayment(paymentHistory, month) {
        const creditSum = this.getCreditSum(),
            creditTerm = this.getCreditTerm();

        if (month && !paymentHistory[month - 1].debt) {
            return paymentHistory[month - 1].writingOff;
        }

        return Math.round((creditSum / creditTerm + paymentHistory[month].writingOff) * 100) / 100;
    }

    defineWritingOff(paymentHistory, month) {
        const creditSum = this.getCreditSum(),
            rate = this.getCreditRate();

        return month === 1
            ? Math.round(
                  ((paymentHistory[month - 1].debt * rate) / 1200 +
                      (creditSum * rate * 4) / (1200 * 31)) *
                      100
              ) / 100
            : Math.round(((paymentHistory[month - 1].debt * rate) / 1200) * 100) / 100;
    }

    calculateMonthBalance(paymentHistory, month) {
        const result = paymentHistory[month - 1].debt - paymentHistory[month].repayment;
        return result > 0 ? result : 0;
    }
}
